import { get } from '../index';

export const getFamilies = (page, size) => {
  return get(`admin/family?page=${page}&size=${size}`);
};